<template>
    <div class="vue-autocomplete">
        <!-- <label>Drug</label> -->
        <v-select
            class="bax-input-control bax-autocomplete"
            :options="options"
            :value="value"
            :placeholder="placeholder"
            @input="onSelect"
            :label="label"
        ></v-select>
    </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
    name: 'BaseSelectAutoComplete',
    components: {
        vSelect,
    },
    data() {
        return {
            selectedValue: '',
        };
    },
    props: {
        label: {
            type: String,
            default: '',
        },
        options: {},
        value: {},
        placeholder: {
            default: '',
        },
    },
    watch: {
        value(data) {
            if (data === '') {
                this.selectedValue = '';
            }
        },
    },
    methods: {
        onSelect(val) {
            this.selectedValue = val;
            this.$emit('input', this.selectedValue);
            this.$emit('change', this.selectedValue);
        },
    },
};
</script>

<style scoped lang="scss">
.vue-autocomplete {
    position: relative;
}
</style>
